import React, { useEffect, useState } from "react";
// import "./Preloader.css"; // Make sure you move your CSS here

const UIHelpers = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => setLoading(false), 2000); // 2s for demo
    return () => clearTimeout(timer);
  }, []);

  // Back to top functionality
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Preloader */}
      {loading && (
        <div id="preloader" className="preloader">
          <div className="animation-preloader">
            <div className="spinner"></div>
            <div className="txt-loading">
              {"TheSpiceRoot".split("").map((letter, idx) => (
                <span key={idx} data-text-preloader={letter} className="letters-loading">
                  {letter}
                </span>
              ))}
            </div>
            <p className="text-center">Loading</p>
          </div>
          <div className="loader">
            <div className="row">
              {[...Array(4)].map((_, idx) => (
                <div
                  key={idx}
                  className={`col-3 loader-section ${idx < 2 ? "section-left" : "section-right"}`}
                >
                  <div className="bg"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Custom Mouse Cursor */}
      <div className="mouse-cursor cursor-outer"></div>
      <div className="mouse-cursor cursor-inner"></div>

      {/* Back to Top */}
      <button id="back-top" className="back-to-top" onClick={scrollToTop}>
        <i className="fa-regular fa-arrow-up"></i>
      </button>
    </>
  );
};

export default UIHelpers;
